import { useParams } from 'react-router-dom'
import axios from 'axios'
import { useAuthHeader, useAuthUser } from 'react-auth-kit'
import { useState, useEffect } from 'react'
import Spinner from '../../usables/small/Spinner'
import ClosingAlert from '../../usables/Alert'
import Card from '../../usables/small/Card'
import Modal from '../../usables/Modal'
import Input from '../../usables/small/Input'

export default function  User() {
  const { id } = useParams()
  const auth  = useAuthHeader()
  const authUser = useAuthUser()
  const [user, setUser] = useState({})
  const [formData, setFormData] = useState({name: '', lastname: '', email: '', phone: ''})
  const [dataLoaded, setDataLoaded] = useState({done: false, sucssess: false, items: 0})
  const [errorMsg, setErrorMsg] = useState('Nepavyko įrašyti reikšmės')
  const [showError, setShowError] = useState(false)

  const config = {
    headers: {
      Authorization: auth()
    }
  }

  const updatePerson = () => {
    axios.patch(process.env.REACT_APP_API + `/people/${user.person.id}`, formData, config)
      .then((res)=>{
        if(res.status === 200){
          var teach = {...user}
          teach.person = res.data.person
          setUser(user)
        }
      })
      .catch((err) => {
        setErrorMsg(err.response.data.message)
        setShowError(true)
      })
    }

  useEffect(() => {
    axios.get(process.env.REACT_APP_API + `/user/${id}`, config)
    .then(res => {
      if(res.status === 200){
        setUser(res.data.user)
        setFormData({name: res.data.user.person.name, lastname: res.data.user.person.lastname, email: res.data.user.person.email, phone: (res.data.user.person.phone === null) ? '' : res.data.user.person.phone})
        setDataLoaded({done: true, sucssess: true, items: 1})
      }
    })    
    .catch(err => {
      setUser([]) //! Pašalinti prieš buildinant
      //console.log(err.response.data)
      setUser(err.response.data)
      setDataLoaded({done: true, sucssess: false, items: 0})
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
    {dataLoaded.sucssess ? <h2>{user.name}</h2> : null}
    <ClosingAlert type='error' message={errorMsg} show={showError} updateState={(value) => {setShowError(value)}} />
      {!dataLoaded.done
      ? <Spinner />
      : dataLoaded.sucssess
        ?dataLoaded.items
          ? <>
            {/* {JSON.stringify(user)} */}
            <div className="p-10 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-5">
              <Card title='Pagrindinė informacija'>
                <ul className='divide-y divide-gray-200'>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-center space-x-4">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate ">
                          Vardas
                        </p>
                      </div>
                      <div className="inline-flex items-center text-base font-semibold text-gray-900 ">
                        {user.person.name}
                      </div>
                    </div>
                  </li>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-center space-x-4">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate ">
                          Pavardė
                        </p>
                      </div>
                      <div className="inline-flex items-center text-base font-semibold text-gray-900 ">
                        {user.person.lastname}
                      </div>
                    </div>
                  </li>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-center space-x-4">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate ">
                          El. paštas
                        </p>
                      </div>
                      <div className="inline-flex items-center text-base font-semibold text-gray-900 ">
                        {(user.person.email !== null) ? user.person.email : 'nėra'}
                      </div>
                    </div>
                  </li>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-center space-x-4">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate ">
                          Telefonas
                        </p>
                      </div>
                      <div className="inline-flex items-center text-base font-semibold text-gray-900 ">
                        {(user.person.phone !== null) ? user.person.phone : 'nėra'}
                      </div>
                    </div>
                  </li>
                </ul>
                {authUser().roles.admin &&
                <Modal btnText='Redaguoti' title='Redaguoti' saveText='Išsaugoti' submitFunction={() => updatePerson()}>
                  <div className='pt-5'>
                    <Input
                      label='Vardas'
                      name='name'
                      type='text'
                      value={formData.name}
                      onChange={(e)=>setFormData({...formData, name: e.target.value})}
                      />
                    <Input
                      label='Pavardė'
                      name='lastname'
                      type='text'
                      value={formData.lastname}
                      onChange={(e)=>setFormData({...formData, lastname: e.target.value})}
                      />
                    <Input
                      label='El. paštas'
                      name='email'
                      type='email'
                      value={formData.email}
                      onChange={(e)=>setFormData({...formData, email: e.target.value})}
                      />
                    <Input
                      label='Telefonas'
                      name='phone'
                      type='tel'
                      value={formData.phone}
                      onChange={(e)=>setFormData({...formData, phone: e.target.value})}
                      />
                  </div>
                </Modal>}
              </Card>
            </div>
          </>
          : <ClosingAlert type='warning' message='Nerastas jokia informacija' />
        : <ClosingAlert type='error' message='Vartotojs nerastas' />
      }
    </>
  )
}